export default __webpack_public_path__ + "mfa-email-logo.37232cb6f7598b399c5a4af4215b9cbc.svg";